export default __webpack_public_path__ + "static/media/90.b60b8667.png";